export interface IPayloadDriver {
  advisor: number;
  country: string;
  date: string;
  dealer: number;
  hour: number;
  vin: string;
}
